import { MatchSummaries } from "smartstream-widgets/components/PostMatchComponent/types";

export function isPostMatchStatus(matchSummaries: MatchSummaries): boolean {
    return matchSummaries && matchSummaries.matchStatus === 'PostMatch'
}
